import { c as _c } from "react/compiler-runtime";
import { useMediaQueryList } from "@hooks/use-media-query";
import { FilterToolbarLargeScreen } from "@components/common/faro-table/faro-table-filter/filter-toolbar-large-screen";
import { FilterToolbarSmallScreen } from "@components/common/faro-table/faro-table-filter/filter-toolbar-small-screen";
import { FilterToolbarMediumScreen } from "@components/common/faro-table/faro-table-filter/filter-toolbar-medium-screen";
import { Fragment } from "react";
/** Toolbar to show for filter chips for both small and large screens */
export function FaroTableFilter(t0) {
  const $ = _c(8);
  const {
    filterChips
  } = t0;
  const {
    isScreenMdOrSmaller,
    isScreenXs
  } = useMediaQueryList();
  let t1;
  if ($[0] !== filterChips) {
    t1 = Object.values(filterChips).filter(_temp).map(_temp2);
    $[0] = filterChips;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const filterChipComponents = t1;
  if (isScreenXs) {
    let t2;
    if ($[2] !== filterChipComponents) {
      t2 = <FilterToolbarSmallScreen filterChipComponents={filterChipComponents} />;
      $[2] = filterChipComponents;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (isScreenMdOrSmaller) {
    let t2;
    if ($[4] !== filterChipComponents) {
      t2 = <FilterToolbarMediumScreen filterChipComponents={filterChipComponents} />;
      $[4] = filterChipComponents;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== filterChipComponents) {
    t2 = <FilterToolbarLargeScreen filterChipComponents={filterChipComponents} />;
    $[6] = filterChipComponents;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp2(filterChip_0, index) {
  return <Fragment key={index}>{filterChip_0}</Fragment>;
}
function _temp(filterChip) {
  return filterChip !== null;
}